module.exports = __webpack_public_path__ + "img/UsgsOrangeSymbol.4ce3df81.svg";